import Content from "./pages/Content";

const contentRoutes = [
  {
    path: "content",
    element: <Content />,
  },
];

export default contentRoutes;
